import Vue from "vue";
import orgChart from "./OrgChart.vue";

export function load() {
    const selector = "org-chart";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
        createElement(orgChart, {
        props: {
          ...window[selector]
        }
      })
  }).$mount(selector);
}
